import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#060f17] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src="/images/logo.png" alt="Image & Riviere" className="h-12 mb-5" />
            <p className="font-lato text-[#8CA1B0] text-sm leading-relaxed">
              Photographe subaquatique et environnemental. Reveler la vie cachee de nos rivieres.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-montserrat text-xs uppercase tracking-widest text-[#7DD4F5] mb-5">Navigation</h4>
            <div className="flex flex-col gap-3">
              {['/', '/qui-suis-je', '/prestations', '/galerie', '/contact', '/telechargements'].map((path, i) => (
                <Link
                  key={path}
                  to={path}
                  data-testid={`footer-link-${i}`}
                  className="font-lato text-sm text-[#8CA1B0] hover:text-[#F5F7F9] transition-colors"
                >
                  {['Accueil', 'Qui suis-je ?', 'Prestations', 'Galerie', 'Contact', 'Centre de telechargement'][i]}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-montserrat text-xs uppercase tracking-widest text-[#7DD4F5] mb-5">Contact</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3 text-sm text-[#8CA1B0]">
                <Phone size={14} className="text-[#2B7BA8]" />
                <span>06.47.78.67.90</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-[#8CA1B0]">
                <Mail size={14} className="text-[#2B7BA8]" />
                <span>contact@image-riviere.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-[#8CA1B0]">
                <MapPin size={14} className="text-[#2B7BA8]" />
                <span>France</span>
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-montserrat text-xs uppercase tracking-widest text-[#7DD4F5] mb-5">Suivez-moi</h4>
            <div className="flex gap-4">
              {[
                { icon: Facebook, url: 'https://www.facebook.com/profile.php?id=549048752&locale=fr_FR' },
                { icon: Instagram, url: 'https://www.instagram.com/yannickgouguenheim/?hl=fr' },
                { icon: Linkedin, url: 'https://www.linkedin.com/in/yannick-gouguenheim-268b9b119/' },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-link-${i}`}
                  className="w-10 h-10 rounded-full glass-light flex items-center justify-center text-[#8CA1B0] hover:text-[#7DD4F5] hover:border-[#2B7BA8] transition-all duration-300"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-lato text-xs text-[#8CA1B0]">
            <span className="font-bold">Un site Zen Marketing - <a href="https://zen-marketing.link/formation-seo-toulouse-guide-complet" target="_blank" rel="noopener noreferrer" className="text-[#7DD4F5] hover:text-white transition-colors">Formation SEO à Toulouse</a></span>
            <br />
            &copy; {new Date().getFullYear()} Yannick Gouguenheim — Image & Rivière. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            <span className="font-lato text-xs text-[#8CA1B0] cursor-pointer hover:text-[#F5F7F9] transition-colors">
              Mentions legales
            </span>
            <span className="font-lato text-xs text-[#8CA1B0] cursor-pointer hover:text-[#F5F7F9] transition-colors">
              Politique de confidentialite
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
